import { render, staticRenderFns } from "./TbPay.vue?vue&type=template&id=1cb2d37a&scoped=true&"
import script from "./TbPay.vue?vue&type=script&lang=js&"
export * from "./TbPay.vue?vue&type=script&lang=js&"
import style0 from "./TbPay.vue?vue&type=style&index=0&id=1cb2d37a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb2d37a",
  null
  
)

export default component.exports